import { render, staticRenderFns } from "./EventsMapPage.vue?vue&type=template&id=771ef64c&scoped=true"
import script from "./EventsMapPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsMapPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventsMapPage.vue?vue&type=style&index=0&id=771ef64c&prod&lang=scss&scoped=true"
import style1 from "./EventsMapPage.vue?vue&type=style&index=1&id=771ef64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ef64c",
  null
  
)

export default component.exports